import React, { useCallback, useState } from 'react';
import './ContentShortcut.css';
import ApiServices from "../../utils/apiServices";
import { useEffect } from 'react';
import { Popover } from 'react-tiny-popover';
import trackingService from "../../services/trackingService";
import ScientificCommunicationDocumentsTileGenAIRecom from "./ScientificCommunicationDocumentTitleGenAIRecom";
import {
    imsLoader
} from "../../assets";
import LabelingDocumentsGenAIRec from "./LabelingDocumentGenAIRec";
import MedicalInsightTileGenAIRec from "./MedicalInsightTileGenAIRec";
import KeyMedicalLitDocTileGenAiRec from "./KeyMedicalLitDocTileGenAIRec";
import SubmissionRelatedClinicalSafteyGenAIRec from "./SubmissionRelatedClinicalSafteyGenAIRec";
import KeyCongressLitGenAIRec from "./KeyCongressLitGenAIRec";
import EducationandTrainingDocGenAIRec from "./EducationalTrainingDocGenAIRec";
import CopyReviewPiecesGenAIRec from "./CopyReviewPiecesGenAIRec";
import TAamdDiseasesGenAIRec from './TAandDiseasesGenAIRec';
import AdministrationAndDosagesGenAIRec from './AdministrationAndDosagesGenAIRec';
import EstablishedProductGenAIRec from './EstablishedProductGenAIRec';
import MCETTemplatesDocumentsTile from './MCETTemplatesDocumentsTile';
import GMAFGenAIRec from './GMAFGenAIRec';
import axios from "axios";
import { LocationOrigin } from "../../utils/utilityServices";
import { Authentication } from "../../utils/authenticationUtilityServices";
import ConfirmMessagePopUpModal from "../GenAIPopUp/ConfirmMessagePopUpModal";

const ContentShortcuts = ({ customWidth, customHeight, updateSCAddForHome }) => {

    const [showAnDCSModal, setShowAnDCSModal] = useState(false);
    const [showSRnCSModal, setShowSRnCSModal] = useState(false);
    const [showEnTCSModal, setShowEnTCSModal] = useState(false);
    const [showKMLCSModal, setShowKMLCSModal] = useState(false);
    const [showKCLCSModal, setShowKCLCSModal] = useState(false);
    const [showLDCSModal, setShowLDCSModal] = useState(false);
    const [showSCDCSModal, setShowSCDCSModal] = useState(false);
    const [showCRPCSModal, setShowCRPCSModal] = useState(false);
    const [showTAnDCSModal, setShowTAnDCSModal] = useState(false);
    const [showEPCSModal, setShowEPCSModal] = useState(false);
    const [showMIRCSModal, setShowMIRCSModal] = useState(false);
    const [showMCECSModal, setShowMCECSModal] = useState(false);
    const [showGMAFCSModal, setShowGMAFCSModal] = useState(false);
    const [McetList, setMcetList] = useState([]);
    const [isLoaded, setisLoaded] = useState(false);
    const [products, setProducts] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState("");
    const [selectedUniqueKey, setSelectedUniqueKey] = useState("");
    const [SavedShortcuts, setSavedShortcuts] = useState([]);
    const [GMAFProducts, setGMAFProducts] = useState([]);
    useEffect(() => {
        if (!selectedProduct && (products && products.length > 0)) {
            setSelectedProduct(products[0])
        }
    }, [products, selectedProduct]);
    const urlGenerator = useCallback((item) => {
        let url = ``;
        let { orderedBy, orderedFor } = item;
        if (!orderedBy) orderedBy = '';
        if (!orderedFor) orderedFor = '';
        if (item.domain === 'RIMdocs' || item.domain === 'RIMdocs_LL' || item.domain === 'CTGov') {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            // url = `/DocURL?ID=${item.docTitle}&cs=${item.domain}`
        }
        else if (item.domain === 'SKM' || item.domain === "MIAs") {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
        }
        else if (item.domain === 'EmeaEPs') {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
        }
        else {
            url = `/DocURL?ID=${item.docID}&cs=${item.domain}&connID=${item.connID}&csID=${item.csID}&fileType=${item.fileExtension}&docVer=${item.majorVersionNumber}&fileName=${encodeURIComponent(item.docTitle)}&orderedBy=${orderedBy}&orderedFor=${orderedFor}`
            if (item.a_status === "Approved Needs Review" || item.status === "Approved Needs Review") {
                url = url + `&docState=anr`
            }
        }
        if (item.enclosureDocID) {
            url += `&enclosureID=${item.enclosureDocID}`
        }

        return url
    }, []);
    const runSearch = useCallback(async () => {
        var url = LocationOrigin + process.env.REACT_APP_IMS_API_PREFIX + 'qp/runSearch'
        var config;

        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        config = {
            method: 'POST',
            url: url,
            headers: _headers,
            data: {
                // "from": 0,
                // "size": 25,
                "f1": "csID",
                "fval1": "46",
                "fcount": 1,
                "source": "connID;csID;docID;fileExtension;majorVersionNumber;fileName;docTitle;status;domain;enclosureDocID;searchID;documentNumber;",
                sortBy: "asc",
                sortField: "docTitle",
            }
        }
        return axios(config)
            .then((response) => {
                if (response.data.body.hits.total.value > 0 && response.data.body &&
                    response.data.body.hits && response.data.body.hits.hits) {
                    let firstmcettlist = response.data.body.hits.hits.filter(x => x._source.documentNumber === "US-SFM-7624");
                    let othermcettlist = response.data.body.hits.hits.filter(x => x._source.documentNumber !== "US-SFM-7624");
                    let _mcettList = firstmcettlist.concat(othermcettlist).map(x => { return { docTitle: x._source.docTitle, docURL: urlGenerator(x._source) } });
                    setMcetList(_mcettList);
                }
            })
            .catch(function (error) {
                console.log(error);
            })
    }, [urlGenerator]);
    const getShortcutforHomePageByuserId = useCallback(async () => {
        let service = new ApiServices();
        let wwid = JSON.parse(localStorage.getItem('wwid'));
        await service.getShortcutforHomePageByuserId(wwid)
            .then((response) => {
                setSavedShortcuts(response)
            }).catch((error) => {
                setSavedShortcuts([])
                console.log(error);
            }).finally(() => {
            });
    }, []);

    const getDCSVVProducts = useCallback(async () => {

        var url = LocationOrigin + '/api/dcs-vv/get-products?csid=47'
        var config;

        const _headers = {
            'Content-Type': 'application/json'
        }
        if (await Authentication.isAccessTokenAvailable()) {
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
        }
        config = {
            method: 'GET',
            url: url,
            headers: _headers,

        }
        return axios(config)
            .then((response) => {
                if (response.data && response.data.status && response.data.status === "SUCCESS") {
                    setGMAFProducts(response.data.products)
                }
                else {
                    setGMAFProducts([])
                }
                //console.log("response", response)
            })
            .catch(function (error) {
                if (window.location.origin === 'http://localhost:3000'
                    || window.location.origin === 'https://predev-ims.jnj.com') {
                    setGMAFProducts(["ACI-JEL", "ACIPHEX", "AKEEGA", "Abiraterone Acetate", "DARZALEX", "DARZALEX SC", "INLEXZO", "No Product", "REMICADE", "TALVEY", "aberela", "achillion HCV compounds"])
                }
                else {
                    setGMAFProducts([])
                }

                console.log(error);
            })
    }, []);
    useEffect(() => {
        const initializeShortcuts = async () => {
            let service = new ApiServices();
            let wwid = JSON.parse(localStorage.getItem('wwid'));
            let isProductsAvailable;
            await runSearch();
            await getShortcutforHomePageByuserId();
            await getDCSVVProducts();
            let res = await service.getUserProductAndWwid(wwid);
            if (res) {
                isProductsAvailable = res[0].products;
            }
            if (isProductsAvailable !== null && isProductsAvailable?.length > 0) {
                setProducts(isProductsAvailable.split(";"));
                setisLoaded(true);
            } else {
                setisLoaded(true);
            }
        };

        initializeShortcuts();
    }, [getShortcutforHomePageByuserId, runSearch]);
    const handleCSKP = () => {
        let url = `/CSKP`;
        window.open(
            url,
            "",
            `width=${window.innerWidth},height=${window.innerHeight},toolbar=no,location=no,directories=no,status=no,menubar=no,scrollbars=no,resizable=no,copyhistory=no`
        );
    };
    const closeAllModal = async () => {
        await setSelectedUniqueKey("");
        await setShowAnDCSModal(false);
        await setShowSRnCSModal(false);
        await setShowKMLCSModal(false);
        await setShowEnTCSModal(false);
        await setShowKCLCSModal(false);
        await setShowLDCSModal(false);
        await setShowSCDCSModal(false);
        await setShowCRPCSModal(false);
        await setShowTAnDCSModal(false);
        await setShowEPCSModal(false);
        await setShowMIRCSModal(false);
        await setShowMCECSModal(false);
        await setShowGMAFCSModal(false);
    }
    const indexTrackingData = (uniqueKey) => {
        const ts = new trackingService();
        ts.indexTrackingData(
            localStorage.getItem("userdisplayName"),
            localStorage.getItem("wwid"),
            localStorage.getItem("username"),
            localStorage.getItem("function"),
            localStorage.getItem("region"),
            localStorage.getItem("userproducts"),
            localStorage.getItem("doctypepref"),
            localStorage.getItem("sid"),
            localStorage.getItem("deviceType"),
            localStorage.getItem("deviceOS"),
            localStorage.getItem("browserName"),
            localStorage.getItem("browserVersion"),
            localStorage.getItem("jnjDepartment"),
            localStorage.getItem("companyname"),
            keyValueForCS[uniqueKey],//"Expanded Established Products tile under content shortcuts",
            "",
            window.location.href
            //   this.state.searchKeyword,
            //   this.props.appliedFilters
        );
    }
    const handelSCCardDetail = async (e, uniqueKey, isClicked) => {
        await closeAllModal();
        if (!(e && e.target
            && e.target.classList && (e.target.classList.contains('cs-shortcut-inner-add-to-home')))) {
            if (isClicked) {
                setSelectedUniqueKey(uniqueKey)
                indexTrackingData(uniqueKey)
            }
            if (uniqueKey === "SCDCS") {
                setShowSCDCSModal(isClicked)
            }
            else if (uniqueKey === "LDCS") {
                setShowLDCSModal(isClicked)
            }
            else if (uniqueKey === "MIRCS") {
                setShowMIRCSModal(isClicked)
            }
            else if (uniqueKey === "KMLCS") {
                setShowKMLCSModal(isClicked)
            }
            else if (uniqueKey === "SRnCS") {
                setShowSRnCSModal(isClicked)
            }
            else if (uniqueKey === "KCLCS") {
                setShowKCLCSModal(isClicked)
            }
            else if (uniqueKey === "EnTCS") {
                setShowEnTCSModal(isClicked);
            }
            else if (uniqueKey === "CRPCS") {
                setShowCRPCSModal(isClicked);
            }
            else if (uniqueKey === "CSKPCS") {
                handleCSKP();
            }
            else if (uniqueKey === "TAnDCS") {
                setShowTAnDCSModal(isClicked);
            }
            else if (uniqueKey === "AnDCS") {
                setShowAnDCSModal(isClicked);
            }
            else if (uniqueKey === "EPCS") {
                setShowEPCSModal(isClicked);
            }
            else if (uniqueKey === "MCECS") {
                setShowMCECSModal(isClicked);
            }
            else if (uniqueKey === "GMAFCS") {
                setShowGMAFCSModal(isClicked);
            }
        }
    }

    const handelSCAddToHome = async (uniqueKey) => {
        setisLoaded(false);
        let service = new ApiServices();
        let wwid = JSON.parse(localStorage.getItem('wwid'));
        await service.insertAddToHomePage(uniqueKey, wwid)
            .then(async (response) => {
                await getShortcutforHomePageByuserId();
                await updateSCAddForHome();
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                setisLoaded(true);
            });
    }
    const handelSCRemoveFromHome = async (_id) => {
        setisLoaded(false);
        let service = new ApiServices();
        await service.deleteAddToHomePage(_id)
            .then(async (response) => {
                await getShortcutforHomePageByuserId();
                await updateSCAddForHome();
            }).catch((error) => {
                console.log(error);
            }).finally(() => {
                setisLoaded(true);
            });
    }
    return (<>
        {isLoaded ? <>

            <div className="cs-container">
                {defaultRows.map((row, rIdx) => (
                    <div className="cs-row" key={rIdx}>
                        {row.map((item, cIdx) => {
                            let _positions = ['top'];
                            let _align = 'start'
                            if (cIdx === 3) {
                                _positions = ['top', 'left'];
                                _align = 'end';
                            }
                            let _findSavedShortcuts = SavedShortcuts.find(x => x.cs_key === item.uniqueKey);
                            return (<>
                                <Popover
                                    isOpen={selectedUniqueKey === item.uniqueKey}
                                    positions={_positions}
                                    align={_align}
                                    reposition={false}
                                    scrollable
                                    containerClassName='cs-shortcut-popover-container popoverAvoidClickOutside'
                                    onClickOutside={(e) => {
                                        if (!(e && e.srcElement && e.srcElement.classList &&
                                            (e.srcElement.classList.contains('popoverAvoidClickOutside') ||
                                                e.srcElement.closest(".react-tiny-popover-container") ||
                                                e.srcElement.closest(".popoverAvoidClickOutside")))) {
                                            closeAllModal();
                                        }
                                    }} // This is the key!
                                    content={(positions, align) => (<>
                                        {selectedUniqueKey === "SCDCS" &&
                                            <ScientificCommunicationDocumentsTileGenAIRecom
                                                isFiltersShow={false}
                                                handelSCDCardDetail={(e) => handelSCCardDetail(e, "SCDCS", e)}
                                                showSCDCSModal={showSCDCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />}
                                        {selectedUniqueKey === "LDCS" &&
                                            <LabelingDocumentsGenAIRec
                                                isFiltersShow={false}
                                                handelLDCardDetail={(e) => handelSCCardDetail(e, "LDCS", e)}
                                                showLDCSModal={showLDCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />}

                                        {selectedUniqueKey === "MIRCS" &&
                                            <MedicalInsightTileGenAIRec
                                                isFiltersShow={false}
                                                handelMIRCardDetail={(e) => handelSCCardDetail(e, "MIRCS", e)}
                                                showMIRCSModal={showMIRCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                            />
                                        }
                                        {selectedUniqueKey === "KMLCS" &&
                                            <KeyMedicalLitDocTileGenAiRec
                                                isFiltersShow={false}
                                                handelKMLCardDetail={(e) => handelSCCardDetail(e, "KMLCS", e)}
                                                showKMLCSModal={showKMLCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />}
                                        {selectedUniqueKey === "SRnCS" &&
                                            <SubmissionRelatedClinicalSafteyGenAIRec
                                                isFiltersShow={false}
                                                handelSRnCSCardDetail={(e) => handelSCCardDetail(e, "SRnCS", e)}
                                                showSRnCSModal={showSRnCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />
                                        }
                                        {selectedUniqueKey === "KCLCS" &&
                                            <KeyCongressLitGenAIRec
                                                isFiltersShow={false}
                                                handelKCLCardDetail={(e) => handelSCCardDetail(e, "KCLCS", e)}
                                                showKCLCSModal={showKCLCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />
                                        }
                                        {selectedUniqueKey === "EnTCS" &&
                                            <EducationandTrainingDocGenAIRec
                                                isFiltersShow={false}
                                                handelEnTCardDetail={(e) => handelSCCardDetail(e, "EnTCS", e)}
                                                showEnTCSModal={showEnTCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />
                                        }
                                        {selectedUniqueKey === "CRPCS" &&

                                            <CopyReviewPiecesGenAIRec
                                                isFiltersShow={false}
                                                handelCRPCardDetail={(e) => handelSCCardDetail(e, "CRPCS", e)}
                                                showCRPCSModal={showCRPCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />
                                        }
                                        {selectedUniqueKey === "TAnDCS" &&
                                            <TAamdDiseasesGenAIRec
                                                isFiltersShow={false}
                                                handelTADCardDetail={(e) => handelSCCardDetail(e, "TAnDCS", e)}
                                                showSCDCSModal={showTAnDCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />
                                        }
                                        {selectedUniqueKey === "AnDCS" &&

                                            <AdministrationAndDosagesGenAIRec
                                                isFiltersShow={false}
                                                handelCRPCardDetail={(e) => handelSCCardDetail(e, "AnDCS", e)}
                                                showCRPCSModal={showAnDCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />
                                        }
                                        {selectedUniqueKey === "EPCS" &&

                                            <EstablishedProductGenAIRec
                                                isFiltersShow={false}
                                                handelEPCardDetail={(e) => handelSCCardDetail(e, "EPCS", e)}
                                                showEPCSModal={showEPCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                            />
                                        }
                                        {selectedUniqueKey === "GMAFCS" &&
                                            <GMAFGenAIRec
                                                handelGMAFCardDetail={(e) => handelSCCardDetail(e, "GMAFCS", e)}
                                                showGMAFCSModal={showGMAFCSModal}
                                                GMAFProducts={GMAFProducts}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                            />
                                        }
                                        {selectedUniqueKey === "MCECS" &&
                                            <MCETTemplatesDocumentsTile
                                                isFiltersShow={false}
                                                showEPCSModal={showEPCSModal}
                                                customWidth={customWidth}
                                                customHeight={customHeight}
                                                products={products}
                                                selectedProduct={selectedProduct}
                                                handelMCETCardDetail={(e) => handelSCCardDetail(e, "MCECS", e)}
                                                showMCECSModal={showMCECSModal}
                                                mcetList={McetList}
                                            />
                                        }
                                    </>
                                    )}>
                                    <div />
                                </Popover>
                                <ContentShortcut
                                    key={cIdx}
                                    title={item.title}
                                    subtitle={item.subtitle}
                                    uniqueKey={item.uniqueKey}
                                    customWidth={customWidth}
                                    customHeight={customHeight}
                                    products={products}
                                    selectedProduct={selectedProduct}
                                    handelSCCardDetail={handelSCCardDetail}
                                    handelSCAddToHome={handelSCAddToHome}
                                    handelSCRemoveFromHome={handelSCRemoveFromHome}
                                    savedShortcut={_findSavedShortcuts} />
                            </>
                            )
                        }
                        )}
                    </div>
                ))}
            </div>

        </> : <div style={{ textAlign: "center", padding: "10%", background: "#fff" }}>
            <img src={imsLoader} alt="Loading Data" style={{ width: "10%" }} />
        </div>}

    </>
    );
};

export default ContentShortcuts;
const keyValueForCS = {
    SCDCS: "Expanded Scientific Communication Documents tile under content shortcuts",
    LDCS: "Expanded Labeling Documents tile under content shortcuts",
    MIRCS: "Expanded iMedical Insights Reports tile under content shortcuts",
    KMLCS: "Expanded Key Medical Literature Documents tile under content shortcuts",
    SRnCS: "Expanded Submission-Related and Clinical Safety Documents tile under content shortcuts",
    TAnDCS: "Expanded TA and Disease Dashboards tile under content shortcuts",
    KCLCS: "Expanded Key Congress Literature Documents tile under content shortcuts",
    CSKPCS: "Expanded Clinical Studies Knowledge Panel tile under content shortcuts",
    EnTCS: "Expanded Education & Training Documents tile under content shortcuts",
    CRPCS: "Expanded Copy Review Pieces tile under content shortcuts",
    AnDCS: "Expanded Routes of Administration and Dosages tile under content shortcuts",
    EPCS: "Expanded Established Products tile under content shortcuts",
    MCECS: "Expanded MCET Templates tile under content shortcuts",
    GMAFCS: "Expanded Global Medical Affairs Resources tile under content shortcuts",
}
let defaultRows = [
    [
        {
            "title": "Labeling Documents",
            "subtitle": "(US, EU, and Rest of World)",
            "uniqueKey": "LDCS",
            "sort": 1
        },
        {
            "title": "MCET Templates",
            "subtitle": "(Core Assets)",
            "uniqueKey": "MCECS",
            "sort": 2
        },
        {
            "title": "Global Medical Affairs Resources",
            "subtitle": "(GMAF)",
            "uniqueKey": "GMAFCS",
            "sort": 3
        },
        {
            "title": "Submission-Related and Clinical Safety Documents",
            "subtitle": "(CSRs, Protocols, IBs, RMPs, etc.)",
            "uniqueKey": "SRnCS",
            "sort": 4
        },
    ],
    [
        {
            "title": "Scientific Communication Documents",
            "subtitle": "(Scientific Responses, Slide Decks, etc.)",
            "uniqueKey": "SCDCS",
            "sort": 5
        },

        {
            "title": "TA and Disease Dashboards",
            "subtitle": "",
            "uniqueKey": "TAnDCS",
            "sort": 6
        },
        {
            "title": "Clinical Studies Knowledge Panel",
            "subtitle": "(Quick access to data about JNJ studies and corresponding scientific evidence)",
            "uniqueKey": "CSKPCS",
            "sort": 7
        },
        {
            "title": "Key Medical Literature Documents",
            "subtitle": "(JNJ and Key Competitor)",
            "uniqueKey": "KMLCS",
            "sort": 8
        },
    ],
    [
        {
            "title": "Education & Training Documents",
            "subtitle": "(eLearning Modules, FAQs, etc.)",
            "uniqueKey": "EnTCS",
            "sort": 9
        }, {
            "title": "iMedical Insights Reports",
            "subtitle": "(IMedical Digest)",
            "uniqueKey": "MIRCS",
            "sort": 10
        },
        {
            "title": "Key Congress Literature Documents",
            "subtitle": "(Posters/Abstracts/Oral Presentations: 2022-2026)",
            "uniqueKey": "KCLCS",
            "sort": 11
        },
        {
            "title": "Copy Review Pieces",
            "subtitle": "(Promotional Materials)",
            "uniqueKey": "CRPCS",
            "sort": 12
        },

    ],
    [{
        "title": "Established Products",
        "subtitle": "(Direct Access to EP Content by Product)",
        "uniqueKey": "EPCS",
        "sort": 13
    },]
]

// if (window.location.origin === 'http://localhost:3000'
//     || window.location.origin === 'https://predev-ims.jnj.com') {
//     defaultRows.push()
// }

const ContentShortcut = ({ title, subtitle, uniqueKey, customWidth, customHeight, selectedProduct, products, handelSCCardDetail, handelSCAddToHome, handelSCRemoveFromHome, savedShortcut }) => {
    const [confirmMessageContent, setConfirmMessageContent] = useState('');
    const [confirmMessageShowModal, setConfirmMessageShowModal] = useState(false);

    const showConfirmMessage = (message) => {
        setConfirmMessageContent(message);
        setConfirmMessageShowModal(true);
    }


    const confirmHandler = async () => {
        setConfirmMessageContent("");
        setConfirmMessageShowModal(false);
        handelSCRemoveFromHome(savedShortcut.id)

    }


    const closeConfirmMessage = () => {
        setConfirmMessageContent("");
        setConfirmMessageShowModal(false);
    }

    return (<>
        <div className="cs-shortcut" role="group" aria-label={title} onClick={(e) => handelSCCardDetail(e, uniqueKey, true)}>
            <div className="cs-shortcut-inner">
                <div className="cs-shortcut-title">{title}</div>
                <div className="cs-shortcut-subtitle">{subtitle}</div>
            </div>
            <div className="cs-shortcut-inner-add-remove-home-page">
                {savedShortcut ? <>
                    <span className='cs-shortcut-inner-add-to-home cs-shortcut-inner-add-remove-home-page-span popoverAvoidClickOutside' onClick={(e) =>
                        showConfirmMessage("Are you sure you want to remove this content shortcut from home screen?")
                    }>
                        <svg width="10" height="10" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M29.9082 17.6713L2.09398 17.6554L2.09206 14.3034L29.9062 14.3192L29.9082 17.6713Z" fill="#EB1700" />
                        </svg>
                        &nbsp;Remove From Home Screen</span></> : <>
                    <span className='cs-shortcut-inner-add-to-home cs-shortcut-inner-add-remove-home-page-span popoverAvoidClickOutside' onClick={(e) => handelSCAddToHome(uniqueKey)}>
                        <svg width="10" height="10" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M17.6772 17.6643L29.9082 17.6713L29.9062 14.3192L17.6753 14.3122L17.6683 2.08127L14.3162 2.07935L14.3232 14.3103L2.09206 14.3034L2.09398 17.6554L14.3251 17.6624L14.3321 29.8935L17.6842 29.8954L17.6772 17.6643Z" fill="#EB1700" />
                        </svg>
                        &nbsp;Add To Home Screen</span></>}
            </div>
        </div>
        {
            confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => closeConfirmMessage()} handleConfirm={() => confirmHandler()} />
        }
    </>
    )
};
